import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import { Loading, Toast } from 'zarm';
import { getOrderDetail } from '@/services/order';
import { dispatch, getState } from '@/store';
import { isPreviewMode, isTemplateToolMode, isTemplateMode, getQueryParam } from '@/utils/tool';
import { premiumCalculate } from '@/services/JDservice';
import SingleAlert from '@/components/SingleAlert/singleAlert';
import ZaToast from '@/components/ZaToast';
import { FETCH_STORE } from '@/constants';
export const useQueryOrderDetail = () => {
  const index = useRef(0);
  const [personList, setPersonList] = useState([]);
  useEffect(() => {
    const fetchStore = getState(FETCH_STORE) || {};
    const {
      orderNo,
      encryptOrderNo
    } = getQueryParam();
    const urlParams = getQueryParam();

    const params = _objectSpread(_objectSpread({
      // orderNo: 2021032616593533152525,
      orderNo,
      encryptOrderNo,
      needAllInsured: true
    }, urlParams), fetchStore);

    Loading.show();
    getOrderDetail(params).then(res => {
      var _insuredList$;

      index.current += 1;
      Loading.hide();
      const {
        success,
        message,
        result
      } = res;

      if (!success) {
        Toast.show(message || '网络错误');
        return;
      }

      const {
        holder = {},
        insuredList = []
      } = result || {};
      const list = [];

      if (result !== null && result !== void 0 && result.holder) {
        list.push(_objectSpread(_objectSpread({}, holder), {}, {
          personType: 'holder'
        }));
      }

      insuredList.forEach(item => {
        item.personType = 'insured';
        list.push(item);
      }); // 检查是否包含豁免险

      const _packageList = ((_insuredList$ = insuredList[0]) === null || _insuredList$ === void 0 ? void 0 : _insuredList$.packageList) || [];

      const hasExemption = _packageList.some(item => {
        return item.holderExemptionInsurance === 'Y';
      });

      setPersonList({
        mixList: list,
        resultObj: result,
        hasExemption
      });
    });
  }, []);

  if (isPreviewMode() || isTemplateToolMode() || isTemplateMode()) {
    return;
  }

  return [personList];
};
export const getPremium = async params => {
  const res = await premiumCalculate(params);
  const {
    code,
    message,
    result
  } = res;

  if (Number(code)) {
    const codeList = ['20000', '20019'];

    if (codeList.includes(code)) {
      const modal = SingleAlert({
        title: '温馨提示',
        content: message,
        onCancel: () => {
          modal.hide();
        }
      });
      return;
    }

    ZaToast.show(message);
    return;
  } // 这里通过改变 PREMIUM 字段触发试算操作栏保费监听


  const {
    insuredList,
    payType,
    initialPremium,
    nextPremium,
    totalSumInsured
  } = result;

  if (payType === undefined) {
    return;
  }

  if (Number(payType) === 1) {
    dispatch({
      insuredListPremium: insuredList,
      totalSumInsured,
      PREMIUM: {
        data: result,
        shit: true,
        type: 'year',
        value: initialPremium
      }
    });
  } else {
    dispatch({
      totalSumInsured,
      insuredListPremium: insuredList,
      PREMIUM: {
        data: result,
        shit: true,
        type: 'month',
        value: [initialPremium, nextPremium]
      }
    });
  }
};